export async function useFetchCancelContractReasons() {
  const runtimeConfig = useRuntimeConfig()
  const client = runtimeConfig.public.client
  const { locale } = useI18n()

  const { data: cancelContractReasons, status } = await useFetch<
    CancelContractReason[]
  >('/customer/cancelContractReasons', {
    baseURL: runtimeConfig.public.apiBaseURL,
    server: false,
    method: 'get',
    query: {
      client: client,
      language: locale.value,
    },
    key: 'dbc-cancel-contract-reasons',
    deep: false,
    transform: (response: any) => {
      return response.data.map((reason: any) => ({
        uid: reason.uid,
        label: reason.description,
        value: reason.uid,
        commentMandatory: reason.commentMandatory,
      }))
    },
  })
  return { cancelContractReasons, status }
}
